import ReactTable from 'react-table'
import styled from 'styled-components'
import React, { Component } from 'react'
import { Input, Popconfirm, Button, Form, Tooltip, Icon, AutoComplete } from 'antd'
import { filterCaseInsensitive, convertToOption, getSelectedOrganization } from '../../util'
import OrganizationQuickAdd from '../organization//OrganizationQuickAdd'
import _ from 'lodash'
import moment from 'moment'

const FormItem = Form.Item

const AddItemVendorContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  background-color: #eeeeee;
`

const ButtonsWithMargin = styled(Button)`
  margin-right: 10px;
`

class ItemVendors extends Component {
  constructor(props) {
    super(props)
    this.state = {
      displayAddItemVendorModal: false,
      currentVendor: null,
      quickAddModalVisibility: false
    }
  }

  handleToggleEditArea = () => {
    this.setState({
      displayAddItemVendorModal: !this.state.displayAddItemVendorModal,
      currentVendor: null
    })
  }

  handleRowItemVendorClick = row => {
    this.setState({
      currentVendor: row,
      displayAddItemVendorModal: true
    })
  }

  handleBlurOrganization = organization => {
    if (organization !== '')
      this.setState({
        quickAddModalVisibility:
          _.findIndex(this.props.allVendors, { id: +organization }) < 0 &&
          _.findIndex(this.props.allVendors, { name: organization }) < 0
            ? true
            : false
      })
  }

  handleCancelQuickAdd = () => {
    this.setState({
      quickAddModalVisibility: !this.state.quickAddModalVisibility
    })
  }

  handleAddItemVendor = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }

      values.item_id = this.props.itemId
      values.created_by_id = this.props.userId
      values.updated_by_id = this.props.userId
      values.created_date = moment().format('YYYY/MM/DD HH:mm:ss')
      values.updated_date = moment().format('YYYY/MM/DD HH:mm:ss')
      values.organization_id = getSelectedOrganization(
        this.props.allVendors,
        values.organization_id
      )

      this.props.handleCreateItemVendor(values)

      form.resetFields()
      this.setState({
        displayAddItemVendorModal: false,
        currentVendor: null
      })
    })
  }

  handleCancelItemVendor = () => {
    this.setState({
      currentVendor: null,
      displayAddItemVendorModal: false
    })
  }

  deleteItemVendor = () => {
    const itemVendorPayload = {
      item_id: this.props.itemId,
      organization_id: this.state.currentVendor.id
    }
    this.props.deleteItemVendor(itemVendorPayload)
    this.setState({
      displayAddItemVendorModal: false,
      currentVendor: null
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    return (
      <div>
        <OrganizationQuickAdd
          modalVisible={this.state.quickAddModalVisibility}
          handleCancel={this.handleCancelQuickAdd}
          handleQuickAddOrganization={this.props.handleQuickAddOrganization}
          organizartionType={'Vendor'}
        />
        <div className="jobsBar">
          Item Vendors
          <div className="jobsBarAdd" onClick={() => this.handleToggleEditArea()}>
            <i className="fa fa-pencil-square" aria-hidden="true" />
            &nbsp;<div className="addJobLabel">ADD VENDOR</div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            {this.state.displayAddItemVendorModal && (
              <AddItemVendorContainer>
                <Form>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="jobDetailsHeader">COMPANY NAME</div>
                      <FormItem>
                        {getFieldDecorator('organization_id', {
                          rules: [
                            {
                              required: true,
                              message: 'You must choose a Vendor'
                            }
                          ],
                          initialValue: this.state.currentVendor
                            ? this.state.currentVendor.name
                            : null
                        })(
                          <AutoComplete
                            dataSource={convertToOption(this.props.allVendors)}
                            filterOption={(inputValue, option) =>
                              option.props.children
                                .toUpperCase()
                                .indexOf(inputValue.toUpperCase()) !== -1
                            }
                            placeholder="Search for some Company"
                            width={320}
                            onBlur={this.handleBlurOrganization}
                          >
                            <Input
                              suffix={<Icon type="search" className="certain-category-icon" />}
                            />
                          </AutoComplete>
                        )}
                      </FormItem>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 d-flex justify-content-end">
                      <Popconfirm
                        title="Are you sure you want to delete this record?"
                        onConfirm={this.deleteItemVendor}
                        onCancel={this.cancelDelete}
                        okText="Yes"
                        cancelText="No"
                      >
                        {this.state.currentVendor && (
                          <Button type="danger" icon="delete" className="mr-2" />
                        )}
                      </Popconfirm>
                      <ButtonsWithMargin onClick={() => this.handleCancelItemVendor()}>
                        Cancel
                      </ButtonsWithMargin>
                      {!this.state.currentVendor && (
                        <ButtonsWithMargin onClick={() => this.handleAddItemVendor()}>
                          Add
                        </ButtonsWithMargin>
                      )}
                    </div>
                  </div>
                </Form>
              </AddItemVendorContainer>
            )}
            <ReactTable
              data={this.props.itemsVendors}
              getTrProps={(state, rowInfo, column, instance) => ({
                onClick: e => this.handleRowItemVendorClick(rowInfo.original)
              })}
              filterable
              defaultFilterMethod={filterCaseInsensitive}
              columns={[
                {
                  columns: [
                    {
                      Header: 'Name',
                      id: 'name',
                      accessor: d => <Tooltip title={d.name}>{d.name}</Tooltip>
                    },
                    {
                      Header: 'Phone Number',
                      id: 'phone_number',
                      accessor: d => <Tooltip title={d.work_number}>{d.work_number}</Tooltip>
                    },
                    {
                      Header: 'Fax Number',
                      id: 'fax_number',
                      accessor: d => <Tooltip title={d.fax_number}>{d.fax_number}</Tooltip>
                    },
                    {
                      Header: 'Address',
                      id: 'address',
                      accessor: d => {
                        const address = `${d.address1} - ${d.address2} ${d.city}, ${d.state} - ${
                          d.zip
                        }`
                        return <Tooltip title={address}>{address}</Tooltip>
                      }
                    }
                  ]
                }
              ]}
              defaultPageSize={5}
              className="-striped -highlight"
            />
          </div>
        </div>
      </div>
    )
  }
}

export default Form.create()(ItemVendors)



// WEBPACK FOOTER //
// ./src/components/item/ItemVendors.js